import React, { PureComponent } from 'react'
import cx from 'classnames'

import { Input, Flex, FormControl, FormErrorMessage } from '@chakra-ui/react'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon'
import styles from './InputNumber.module.less'

export default class FormInput extends PureComponent {
  render() {
    const {
      size,
      prefix,
      prefixCls,
      min,
      maxLength,
      step,
      tabIndex,
      error,
      isRequired,
      setRef,
      disabled,
      name,
      id,
      precision,
      formatter,
      parser,
      decimalSeparator,
      onChange,
      onBlur,
      onFocus,
      type,
      placeholder,
      style,
      className,
      iconOnLeft,
      iconOnRight,
      onLeftIconClick,
      onRightIconClick,
      useBigButtons,
      value,
      onInputChange,
      onInputKeyDown,
      onInputKeyPress,
    } = this.props

    const classNamesInput = cx({
      [className]: !!className,
      [styles.useBigButtons]: !!useBigButtons,
    })

    const fieldProps = {
      size: size ? size : 'large',
      ref: setRef,
      min,
      maxLength,
      step,
      tabIndex,
      disabled,
      name,
      id,
      precision,
      formatter,
      parser,
      decimalSeparator,
      onChange,
      onBlur,
      onFocus,
      type,
      placeholder,
      style,
      prefix,
      prefixCls,
      className: classNamesInput,
    }

    return (
      <FormControl
        isInvalid={error && error.touched && error.error}
        isRequired={isRequired}
        onChange={onInputChange}
      >
        <Flex align={'center'} pos={'relative'}>
          {iconOnLeft ? (
            <Flex
              className={styles.disableSelect}
              zIndex={1}
              pos={'absolute'}
              left={'0'}
              p={'20px'}
              cursor={'pointer'}
            >
              <button
                onClick={e => {
                  e.preventDefault()
                  if (onLeftIconClick) {
                    onLeftIconClick(e)
                  }
                }}
              >
                <FontAwesomeIconComponent icon={iconOnLeft} size='xs' />
              </button>
            </Flex>
          ) : (
            ''
          )}
          <Input
            onKeyPress={onInputKeyPress}
            onKeyDown={onInputKeyDown}
            textAlign={iconOnRight ? 'center' : ''}
            px={'50px'}
            variant={error && error.error && error.touched ? 'error' : 'primary'}
            value={value}
            {...fieldProps}
          />
          {iconOnRight ? (
            <Flex
              className={styles.disableSelect}
              pos={'absolute'}
              right={'0'}
              p={'20px'}
              cursor={'pointer'}
            >
              <button
                onClick={e => {
                  e.preventDefault()
                  if (onRightIconClick) {
                    onRightIconClick(e)
                  }
                }}
              >
                <FontAwesomeIconComponent icon={iconOnRight} size='xs' />
              </button>
            </Flex>
          ) : (
            ''
          )}
        </Flex>
        <FormErrorMessage>{error && error.error}</FormErrorMessage>
      </FormControl>
    )
  }
}
